import React from 'react'

 const CopyRight=(props) =>{
    return (
        <p className="ml-2 mb-1" style={{color:props.color,fontSize:'0.6rem'}}>© 2020 Tayarifood</p>
    )
}
export default CopyRight
